<template>
  <van-popup
    v-model:show="visable"
    class="popup"
    closeable
    :overlay-style="{ zIndex: 3005 }"
    position="bottom"
    round
    :style="{ height: '94%', zIndex: 3006 }"
    @closed="closed"
  >
    <div class="title">{{ title }}</div>
    <iframe v-if="visable" border="none" class="content" :src="src"></iframe>
  </van-popup>
</template>
<script>
  export default {
    data() {
      return {
        visable: false,
        src: '',
        title: '预览',
      }
    },
    methods: {
      show(url, title = '预览') {
        this.visable = true
        this.src = url
        this.title = title
      },
      closed() {
        this.$emit('close')
      },
    },
  }
</script>
<style lang="scss" scoped>
  .popup {
    background: #999;
  }
  .title {
    height: 56px;
    line-height: 56px;
    padding-left: 16px;
    padding-right: 40px;
    background: #f1f1f1;
    overflow: hidden;
  }
  .content {
    border: none;
    width: 100%;
    padding: 0;
    height: calc(100% - 56px);
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>
